import { useState, useRef, useEffect } from "react";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataGridColumnConfig, DataGridRowConfig } from "../types";
import { formatCellContent } from "../utils";
import cn from "classnames";
import { isEmpty } from "lodash";

export const DataGridCellCopy: React.FC<{
    row: DataGridRowConfig;
    column: DataGridColumnConfig;
}> = ({ column, row }) => {
    const [icon, setIcon] = useState<IconName>("copy");
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const action = (content: string) => {
        navigator.clipboard.writeText(content).catch((err) => {
            console.error("Failed to copy!", err);
        });

        setIcon("circle-check");

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setIcon("copy");
            timeoutRef.current = null;
        }, 3000);
    };

    const content = formatCellContent({ ...column, renderer: undefined }, row.data[column.key], row);
    return (
        <>
            {!isEmpty(content) && (
                <div key={`$grid-copy-${column.key}`} className="d-flex align-items-center text-nowrap">
                    {content}
                    <FontAwesomeIcon
                        icon={["far", icon]}
                        onClick={() => action(`${row?.data[column.key]}`)}
                        className={cn(`btn p-0 ms-1 flex-shrink-0`, { "text-success": icon === "circle-check" })}
                        size="sm"
                    />
                </div>
            )}
        </>
    );
};
